import { createFileRoute } from '@tanstack/react-router'

import { PHONG_NHA_STOREFRONT } from '@/common/storefront/storefront.config'
import PhongNhaLayout from '@/layouts/themes/phong-nha/layout'

export const Route = createFileRoute('/phong-nha')({
  beforeLoad: () => ({ storefront: PHONG_NHA_STOREFRONT }),
  component: PhongNhaLayout,
})

